export function isSortable(c) {
    return "isAscending" in c;
}
export const LIST_VIEW_COLUMNS = [
    { label: "", value: "pinned", noSort: true },
    { label: "Data Source", value: "dataSource", isAscending: true },
    { label: "Dataset Name", value: "datasetName", isAscending: true },
    { label: "Data Quality", value: "dataQuality", isAscending: false },
    { label: "Outcome (KPI)", value: "outcomeLabel", isAscending: false },
    { label: "Data Readiness", value: "dataReadiness", isAscending: false },
    { label: "Useful Variables", value: "usefulVariables", isAscending: false },
    { label: "Problematic Predictors", value: "problematicPredictors", isAscending: false },
    { label: "Insights", value: "insights", isAscending: false },
    { label: "Rows", value: "rows", isAscending: false },
    { label: "Columns", value: "columns", isAscending: false },
    { label: "Date Created", value: "dateCreated", isAscending: false },
    { label: "Owner", value: "owner", isAscending: true },
    { label: "", value: "actions", noSort: true },
    { label: "", value: "expand", noSort: true }
];
